import { useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { useCreateJobSchedule } from '../../hooks/useCreateJobSchedule'

interface Props {
  onClose: () => void
}

export const CreateJobSchedule = ({ onClose }: Props) => {
  const { successAlert } = useAlerts()
  const { mutate: create } = useCreateJobSchedule()
  const [name, setName] = useState('')
  const [data, setData] = useState('{}')
  const [errors, setErrors] = useState({
    nameError: false,
  })

  const handleClickCreate = () => {
    if (!name) {
      setErrors({
        nameError: !name,
      })
    } else {
      create(
        {
          name,
          data: JSON.parse(data),
        },
        {
          onSuccess: () => {
            successAlert('Job schedule succesvol aangemaakt')
            onClose()
          },
        },
      )
    }
  }

  return (
    <Dialog open={true} fullWidth>
      <DialogTitle>Job schedule aanmaken</DialogTitle>
      <DialogContent>
        <Box
          sx={{ width: '95%', marginLeft: 'auto', marginRight: 'auto', p: 1 }}
        >
          <FormControl sx={{ width: '100%', p: 1 }}>
            <TextField
              variant="standard"
              label="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={errors['nameError']}
            />
          </FormControl>
          <FormControl sx={{ mt: 3, width: '100%' }}>
            <TextField
              value={data}
              multiline
              rows={6}
              label="Data (JSON)"
              onChange={(e) => setData(e.target.value)}
              required
              error={errors['dataError']}
            />
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button onClick={handleClickCreate} color="primary">
          Aanmaken job schedule
        </Button>
      </DialogActions>
    </Dialog>
  )
}
